<template>
  <div class="le-tp-attr-content">
    <el-form ref="nodeAttrForm" :model="itemModel" class="le-tp-form" :label-width="formParam.minLabelWidth" :size="formParam.formMini">
      <el-collapse v-if="showAttribute" v-model="activeNames" class="le-tp-collapse">
        <el-collapse-item class="le-tp-collapse-item" title="基础属性" name="base">
          <el-col :span="24">
            <el-form-item label="名称" prop="label">
              <el-input v-model="itemModel.attr.label" placeholder="名称" :clearable="true" maxlength="100" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="类型" prop="type">
              <el-radio-group v-model="itemModel.type" size="mini" :disabled="itemStatus === 1" @change="handleChangeEvent">
                <template v-if="itemStatus === 1">
                  <el-radio-button :label="1">icon</el-radio-button>
                  <el-radio-button :label="2">图片</el-radio-button>
                  <el-radio-button :label="3">内置图形</el-radio-button>
                </template>

                <template v-if="itemStatus === 2">
                  <el-radio-button :label="1">直线</el-radio-button>
                  <el-radio-button :label="2">折线</el-radio-button>
                  <el-radio-button :label="3">曲线</el-radio-button>
                </template>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col v-if="itemStatus === 1" :span="24">
            <el-form-item label="图标" prop="iconContent">
              <le-icon-select
                v-model="itemModel.iconContent"
                :icon-type="iconType"
                :init-data="handleSelectorInitDataEvent()"
                :img-render="handleImgRender"
                :clearable="true"
                :readonly="true"
                @change="handleIconChangeEvent">

                <el-select slot="prepend" v-model="iconType" placeholder="类型">
                  <el-option label="icon" value="icon" />
                  <el-option label="图片" value="image" />
                  <el-option label="图形" value="shape" />
                </el-select>
              </le-icon-select>
            </el-form-item>
          </el-col>

          <template v-if="itemStatus === 1">
            <el-col :span="12">
              <el-form-item label="宽度" prop="width">
                <el-input-number v-model="itemModel.attr.width" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="高度" prop="height">
                <el-input-number v-model="itemModel.attr.height" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
              </el-form-item>
            </el-col>

            <template v-if="itemStatus !== 2 && showPosition">
              <el-col :span="12">
                <el-form-item label="x坐标" prop="x">
                  <el-input-number v-model="itemModel.attr.x" controls-position="right" :min="formParam.pointMin" :max="formParam.max" @change="handleChangeEvent" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="y坐标" prop="y">
                  <el-input-number v-model="itemModel.attr.y" controls-position="right" :min="formParam.pointMin" :max="formParam.max" @change="handleChangeEvent" />
                </el-form-item>
              </el-col>
            </template>
          </template>
        </el-collapse-item>

        <el-collapse-item class="le-tp-collapse-item" :title="`${title}样式`" name="style">

          <template v-if="itemStatus === 1 && itemModel.type !== 2">
            <el-col :span="12">
              <el-form-item label="背景色" prop="fill">
                <el-color-picker v-model="itemModel.style.fill" :show-alpha="true" :predefine="predefineColors" @change="handleChangeEvent" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="透明度" prop="opacity">
                <el-input-number v-model="itemModel.style.opacity" controls-position="right" :min="0.1" :max="1" :step="0.1" @change="handleChangeEvent" />
              </el-form-item>
            </el-col>
          </template>

          <el-col v-if="itemModel.type !== 2" :span="12">
            <el-form-item label="描边颜色" prop="stroke">
              <el-color-picker v-model="itemModel.style.stroke" :show-alpha="true" :predefine="predefineColors" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col v-if="itemModel.type !== 2" :span="12">
            <el-form-item label="描边宽度" prop="lineWidth">
              <el-input-number v-model="itemModel.style.lineWidth" controls-position="right" :min="formParam.min" :max="formParam.max" :step="0.5" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="阴影颜色" prop="shadowColor">
              <el-color-picker v-model="itemModel.style.shadowColor" :show-alpha="true" :predefine="predefineColors" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col v-if="itemModel.type !== 2" :span="12">
            <el-form-item label="描边样式" prop="lineDash">
              <el-select v-model="itemModel.style.lineDash" placeholder="描边样式" @change="handleChangeEvent">
                <el-option label="样式一" :value="[5]">
                  <span style="float: left">样式一</span>
                </el-option>
                <el-option label="样式二" :value="[5, 10, 15]">
                  <span style="float: left">样式二</span>
                </el-option>
                <el-option label="样式三" :value="[3]">
                  <span style="float: left">样式三</span>
                </el-option>
                <el-option label="样式四" :value="[5, 5, 5, 5, 15, 15]">
                  <span style="float: left">样式四</span>
                </el-option>
                <el-option label="样式五" :value="[5, 5, 10, 15]">
                  <span style="float: left">样式五</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col v-if="itemModel.type === 2" :span="12">
            <el-form-item label="透明度" prop="opacity">
              <el-input-number v-model="itemModel.style.opacity" controls-position="right" :min="0.1" :max="1" :step="0.1" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="阴影范围" prop="shadowBlur">
              <el-input-number v-model="itemModel.style.shadowBlur" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col v-if="itemStatus === 2" :span="12">
            <el-form-item label="透明度" prop="strokeOpacity">
              <el-input-number v-model="itemModel.style.strokeOpacity" controls-position="right" :min="0.1" :max="1" :step="0.1" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="x偏移量" prop="shadowOffsetX">
              <el-input-number v-model="itemModel.style.shadowOffsetX" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="y偏移量" prop="shadowOffsetY">
              <el-input-number v-model="itemModel.style.shadowOffsetY" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>
        </el-collapse-item>

        <el-collapse-item class="le-tp-collapse-item" :title="`${title}文本`" name="label">
          <el-col :span="24">
            <el-form-item label="文本对齐" prop="textAlign">
              <el-radio-group v-model="itemModel.labelCfg.style.textAlign" size="mini" @change="handleChangeEvent">
                <el-radio-button label="right" title="center 在节点中间位置">靠左</el-radio-button>
                <el-radio-button label="center" title="top 在节点顶部">居中</el-radio-button>
                <el-radio-button label="left" title="bottom 在节点顶部">靠右</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <!--          <el-col :span="24">-->
          <!--            <el-form-item label="字体粗细" prop="fontWeight">-->
          <!--              <el-radio-group v-model="itemModel.labelCfg.style.fontWeight" size="mini" @change="handleChangeEvent">-->
          <!--                <el-radio-button :label="200" title="常规字体粗细">常规字体</el-radio-button>-->
          <!--                <el-radio-button :label="600" title="加粗字体">字体加粗</el-radio-button>-->
          <!--              </el-radio-group>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->

          <el-col v-if="itemStatus === 1" :span="24">
            <el-form-item label="文本位置" prop="position">
              <el-radio-group v-model="itemModel.labelCfg.position" size="mini" @change="handleChangeEvent">
                <el-radio-button label="top" title="top 在节点顶部">顶</el-radio-button>
                <el-radio-button label="left" title="left 在节点左侧">左</el-radio-button>
                <el-radio-button label="center" title="center 在节点中间位置">中</el-radio-button>
                <el-radio-button label="right" title="right 在节点右侧">右</el-radio-button>
                <el-radio-button label="bottom" title="bottom 在节点顶部">底</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          
          <el-col v-if="itemStatus === 2" :span="24">
            <el-form-item label="文本位置" prop="position">
              <el-radio-group v-model="itemModel.labelCfg.position" size="mini" @change="handleChangeEvent">
                <el-radio-button label="start" title="start 在边顶部">顶部</el-radio-button>
                <el-radio-button label="middle" title="middle 在边中间位置">中间</el-radio-button>
                <el-radio-button label="end" title="end 在边顶部">底部</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <!--          <el-col :span="24">-->
          <!--            <el-form-item label="文本字体" prop="fontFamily">-->
          <!--              <el-select v-model="itemModel.labelCfg.fontFamily" class="le-tp-select" placeholder="文本字体">-->
          <!--                <el-option label="无渐变" value="" />-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->

          <el-col v-if="itemStatus === 1" :span="12">
            <el-form-item label="位置偏移" prop="offset">
              <el-input-number v-model="itemModel.labelCfg.offset" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <template v-if="itemStatus === 2">
            <el-col :span="12">
              <el-form-item label="x方向" prop="refX" title="标签在 x 方向的偏移量">
                <el-input-number v-model="itemModel.labelCfg.refX" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="y方向" prop="refY" title="标签在 y 方向的偏移量">
                <el-input-number v-model="itemModel.labelCfg.refY" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="随边旋转">
                <el-radio-group v-model="itemModel.labelCfg.autoRotate" class="le-radio-group-mini" size="mini" title="标签文字是否跟随边旋转" @change="handleChangeEvent">
                  <el-radio-button :label="true">是</el-radio-button>
                  <el-radio-button :label="false">否</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </template>

          <el-col :span="12">
            <el-form-item label="透明度">
              <el-input-number v-model="itemModel.labelCfg.style.opacity" controls-position="right" :min="0.1" :max="1" :step="0.1" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="字体颜色">
              <el-color-picker v-model="itemModel.labelCfg.style.fill" :show-alpha="true" :predefine="predefineColors" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="字体大小">
              <el-input-number v-model="itemModel.labelCfg.style.fontSize" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="描边颜色">
              <el-color-picker v-model="itemModel.labelCfg.style.stroke" :show-alpha="true" :predefine="predefineColors" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="描边宽度">
              <el-input-number v-model="itemModel.labelCfg.style.lineWidth" controls-position="right" :min="formParam.min" :max="formParam.max" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="阴影颜色">
              <el-color-picker v-model="itemModel.labelCfg.style.shadowColor" :show-alpha="true" :predefine="predefineColors" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="阴影范围">
              <el-input-number v-model="itemModel.labelCfg.style.shadowBlur" controls-position="right" :min="0" :max="99999999" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="x偏移量">
              <el-input-number v-model="itemModel.labelCfg.style.shadowOffsetX" controls-position="right" :min="0" :max="99999999" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="y偏移量">
              <el-input-number v-model="itemModel.labelCfg.style.shadowOffsetY" controls-position="right" :min="0" :max="99999999" @change="handleChangeEvent" />
            </el-form-item>
          </el-col>

        </el-collapse-item>
      </el-collapse>

      <div v-if="!showAttribute" class="le-tp-empty">
        <el-empty description="未选择图形元素，无相关数据" />
      </div>
    </el-form>
  </div>
</template>

<script>
import {dataConst} from '../../scripts/conf';
import {attrCore} from '../../scripts/core/logic';
import {deleteEmptyAttrKey} from '../../../../static/scripts/util/obj_util';
import {listTpShapeList} from '../../scripts/data';

export default {
  name: 'LeTpShapeModel',
  data() {
    return {
      formParam: {...dataConst.formParam},
      predefineColors: dataConst.predefineColors,
      activeNames: ['base', 'style', 'label'],
      title: '节点',
      showAttribute: false,
      showPosition: true,
      itemModel: {
        attr: {},
        style: {},
        labelCfg: {
          style: {}
        },
        iconCfg: null
      },
      // 1 node节点、2 edge边、3 combo组
      itemStatus: 1,
      iconType: 'icon'
    };
  },
  created() {
    this.$nextTick(_ => {
      this.initGlobalEvent();
    });
  },
  destroyed() {
    // 销毁自定义全局事件
    this.$bus.$off();
  },
  methods: {
    initGlobalEvent() {
      this.$bus.$on('custom:shape:attrSelected', shapes => {
        // 图形属性标签被激活时、图形和远中时
        this.showAttribute = shapes?.length > 0;
        this.showPosition = shapes?.length === 1;
        if (this.showAttribute) {
          this.handleShapeAttrConvert(shapes[0]);
        }
      });

      this.$emit('after-created');
    },
    loadImageList() {
      // 加载节点图片
      console.log('加载图片');
      return new Promise(resolve => {
        resolve({code: '', data: []});
      });
    },
    loadShapeList() {
      // 加载图形
      console.log('加载图形');
      return new Promise(resolve => {
        resolve({code: '', data: []});
      });
    },
    handleShapeAttrConvert(item) {
      this.itemStatus = attrCore.getItemTypeStatus(item);
      this.title = this.itemStatus === 1 ? '节点' : this.itemStatus === 2 ? '边' : '分组';

      // 解析转换处理后的属性
      const {type, attr, itemStyle, labelCfg} = attrCore.handleAttributeConversion(item);
      this.$set(this.itemModel, 'type', type);


      // 赋值通用属性
      this.itemModel.attr = {...attr};

      if (this.itemStatus === 1) {
        // 如果是节点，补充节点属性数据
        this.itemModel.style = {...itemStyle?.commonStyle, ...itemStyle?.nodeStyle};
        this.itemModel.labelCfg = {...labelCfg?.commonCfg, ...labelCfg?.nodeCfg};

      } else if (this.itemStatus === 2) {
        // 如果是边，补充边样式或文本属性数据
        this.itemModel.style = {...itemStyle?.commonStyle, ...itemStyle?.edgeStyle};
        this.itemModel.labelCfg = {...labelCfg?.commonCfg, ...labelCfg?.edgeCfg};
      }
    },
    handleChangeEvent() {
      this.handleShapeModelUpdateEvent();
    },
    handleShapeModelUpdateEvent(iconCfg) {
      // 处理图形模型数据更新事件
      const model = {...this.itemModel};
      model.iconCfg = iconCfg || null;
      // 清除 model 中空值属性
      deleteEmptyAttrKey(model);
      this.$emit('change', model);
    },
    handleSelectorInitDataEvent() {
      // 处理初始化函数
      if (this.iconType === 'image') {
        return this.loadImageList;
      }
      
      if (this.iconType === 'shape') {
        return listTpShapeList;
      }
    },
    handleIconChangeEvent(content, item) {
      // 改变节点图形
      const iconCfg = {iconType: this.iconType, iconItem: item};
      this.handleShapeModelUpdateEvent(iconCfg);
    },
    handleImgRender(path) {
      // 处理图片渲染路径
      console.log(path, 5656566);
    }
  }
};
</script>

<style scoped>

</style>
